// import { AnnouncementComponent } from "./announcement/announcement.component";
import { AnnouncementBreadCrumbs, AnnouncementRouting } from './announcement/announcement.routing';
import { ComplaintsRouting } from './complaints/complaints.routing';
import { FeedbackBreadCrumbs, FeedBackRouting } from './feedback/feedback.routing';
import { SupportDeskComponent } from './support-desk.component';
import { TickesBreadCrumbs, TicketsRouting } from './tickets/tickets.routing';

export const SupportDeskRouting = [


    { path: '', component: SupportDeskComponent },
    { path: 'feedback', children: FeedBackRouting },
    { path: 'complaint', children: ComplaintsRouting },
    { path: 'announcement', children: AnnouncementRouting },
    { path: 'ticket', children: TicketsRouting },

];


// export const supportDeskBreadCrumbs = [
//     { name: 'Feedback', path: '/feedback', children: FeedbackBreadCrumbs },
//     { name: 'Complaints', path: '/complaint', children: ComplaintbreadCrumbs },
//     { name: 'Announcement', path: '/announcement', children: AnnouncementBreadCrumbs },
//     { name: 'Ticket', path: '/ticket', children: TickesBreadCrumbs },
// ]